import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'rs-active-inactive-icon',
  templateUrl: 'rs-active-inactive-icon.component.html',
  styleUrl: 'rs-active-inactive-icon.component.scss',
  imports: [MatIconModule],
})
export class RsActiveInactiveIconComponent  {
  public condition = input.required<boolean>();
}
